import { render, staticRenderFns } from "./AddressPopup.vue?vue&type=template&id=9cbc6fa2&scoped=true&"
import script from "./AddressPopup.vue?vue&type=script&lang=js&"
export * from "./AddressPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddressPopup.vue?vue&type=style&index=0&id=9cbc6fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbc6fa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
